import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import {
  Button, BUTTON_SIZES, BUTTON_TYPES
} from 'shared/UI/Button'
import { ThemeColorContext } from 'shared/Components/ItemContent/context'


import './style.css.scss'

const NewTabMessage = (props) => {
  const themeColor = useContext(ThemeColorContext)

  const buttonStyle = {
    backgroundColor: themeColor,
    borderColor: themeColor
  }

  const handleOpenNewTabClick = () => {
    props.onClickNewTab && props.onClickNewTab(props.url)
  }

  return (
    <div className="new-tab-message">
      <div className="new-tab-message-content">
        <p>This item is best viewed in a new tab</p>
        <Button
          customStyle={buttonStyle}
          onClick={handleOpenNewTabClick}
          size={BUTTON_SIZES.large}>
          View in new tab
        </Button>
      </div>
    </div>
  )
}

NewTabMessage.propTypes = {
  url: PropTypes.string.isRequired,
  onClickNewTab: PropTypes.func
}

export default NewTabMessage